import React, { FC, ReactNode } from "react"

import parse from "html-react-parser"

import { PinterestSaveButton } from "components/core/PinterestSaveButton"
import { usePostData } from "components/core/Post/Post.hooks"
import { Category, Post } from "types"
import { segmentTrack } from "utils/segmentAnalytics"

import * as S from "./PostSmall.styles"

interface PostSmallProps {
  post: Post
  category?: Category
}

export const PostSmall: FC<PostSmallProps> = ({ post, category }) => {
  const {
    categoryName,
    categoryUrl,
    featuredImage,
    imageProps,
    pinterestButtonProps,
    trackPostView,
  } = usePostData(post, category)

  return (
    <S.Container>
      {featuredImage?.sourceUrl && (
        <>
          <S.Link aria-label={post.title} to={post.uri} onClick={trackPostView}>
            <S.FeaturedImage
              alt={featuredImage?.altText}
              avif={process.env.GATSBY_IMGLITE_AVIF === "true"}
              src={featuredImage.sourceUrl}
              {...imageProps}
            />
          </S.Link>
          <PinterestSaveButton
            description={post.title}
            image={featuredImage.sourceUrl}
            url={post.uri}
            {...pinterestButtonProps}
          />
        </>
      )}
      <S.Subcontainer>
        <S.Link
          to={categoryUrl}
          onClick={() => segmentTrack("blog.category.click")}
        >
          <S.Category>{categoryName}</S.Category>
        </S.Link>
        <S.Link to={post.uri} onClick={trackPostView}>
          <S.Title>{parse(post.title)}</S.Title>
        </S.Link>
        <S.Date>{post.date as ReactNode}</S.Date>
      </S.Subcontainer>
    </S.Container>
  )
}
